var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLinkedin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20.666,
    height: 20.666,
    viewBox: "0 0 20.666 20.666",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "_5279114_linkedin_network_social_network_linkedin_logo_icon",
    "data-name": "5279114_linkedin_network_social network_linkedin logo_icon",
    d: "M10.333,0A10.333,10.333,0,1,1,0,10.333,10.338,10.338,0,0,1,10.333,0ZM7.1,16.14V8.071H4.42V16.14Zm9.672,0V11.513c0-2.479-1.323-3.632-3.088-3.632a2.664,2.664,0,0,0-2.417,1.332V8.071H8.587c.036.757,0,8.069,0,8.069h2.682V11.633a1.834,1.834,0,0,1,.088-.655A1.468,1.468,0,0,1,12.733,10c.97,0,1.359.74,1.359,1.825V16.14Zm-11-11.96a1.4,1.4,0,1,0-.036,2.789h.017A1.4,1.4,0,1,0,5.779,4.18Z",
    fill: "#e4c7ff",
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedin);
export default __webpack_public_path__ + "static/media/linkedin.c3f08172b3ae1498c5cfdfb66367d1b4.svg";
export { ForwardRef as ReactComponent };